var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.8 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.73,
    y1: 0.099,
    x2: 0.199,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee6e61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7866f2"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1156",
    "data-name": "Trac\\xE9 1156",
    d: "M11.2,9.2v9a7.2,7.2,0,0,0,14.4,0v-9a7.2,7.2,0,1,0-14.4,0Zm7.2-3.6A3.6,3.6,0,0,1,22,9.2v9a3.6,3.6,0,1,1-7.2,0v-9A3.6,3.6,0,0,1,18.4,5.6ZM31,16.4a1.8,1.8,0,0,0-1.8,1.8,10.8,10.8,0,1,1-21.6,0,1.8,1.8,0,1,0-3.6,0A14.4,14.4,0,0,0,16.6,32.489V36.2a1.8,1.8,0,0,0,3.6,0V32.489A14.4,14.4,0,0,0,32.8,18.2,1.8,1.8,0,0,0,31,16.4Z",
    transform: "translate(-4 -2)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicHeader);
export default __webpack_public_path__ + "static/media/MicHeader.c6cefb16ec549d3812cb376e4cf94fec.svg";
export { ForwardRef as ReactComponent };